import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import { ShopifyEditorLinkDto } from '@/Domain/api/Shopify/dto/ShopifyEditorLink.dto';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export class ShopifyApi {
  static getEditorLink = (): Promise<ShopifyEditorLinkDto> =>
    httpClient.get(Endpoint.shopify.editorLink).then(ApiMapper.toResponseData);
}
